import ViewRecommendedItems from 'src/pages/ViewRecommendedItems';
import { useContextSelector } from 'use-context-selector';
import SearchProductListView from './SearchProductListView';
import SearchProductPictureView from './SearchProductPictureView';
import { SearchProductDetailsContext } from './SearchProductDetailsContext';
import { SearchProductFiltersContext } from './SearchProductFiltersContext';

const ToggleSearchProductView = () => {
  const selectedView = useContextSelector(
    SearchProductFiltersContext,
    (context) => context.selectedView
  );
  const isSwapItemModalOpen = useContextSelector(
    SearchProductDetailsContext,
    (context) => context.isSwapItemModalOpen
  );
  const setIsSwapItemModalOpen = useContextSelector(
    SearchProductDetailsContext,
    (context) => context.setIsSwapItemModalOpen
  );
  const swapItemData = useContextSelector(
    SearchProductDetailsContext,
    (context) => context.swapItemData
  );

  return (
    <>
      <div
        className="flex h-full min-h-0 w-full flex-col overflow-hidden"
        style={{ gridArea: 'main' }}
      >
        {selectedView === 0 ? <SearchProductListView /> : <SearchProductPictureView />}
      </div>
      <ViewRecommendedItems
        isOpenSidePanel={isSwapItemModalOpen}
        onCloseSidePanel={() => setIsSwapItemModalOpen(false)}
        isInternal={true}
        dataParams={swapItemData}
      />
    </>
  );
};

export default ToggleSearchProductView;
